import { useEffect } from 'react'
import { dynamicSort } from '../../../common/Helpers';
import { getAllBusinessUnits, getBusinessUnits, getBusinessUnitsFiltred } from '../../../services/sBook/businessUnit.service';

const useGetBusinessUnitsMaintainer = (businessUnits, setBusinessUnits) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getBusinessUnits();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setBusinessUnits(response.data);
                }
                else {
                    setBusinessUnits([]);
                }
            }
            catch (error) {
                setBusinessUnits([]);
            }
        }
        
        if (businessUnits === null) {
            getData()
        }
    }, [businessUnits, setBusinessUnits,]);
}
const useGetBusinessUnits = (businessUnits, setBusinessUnits) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllBusinessUnits();
                const response = serviceResponse.data;
                const aux_array = [];

                if (response.succeeded) {
                    response.data.forEach(element => {
                        aux_array.push({
                            key: element.id,
                            text: `${element.code}`,
                            title:  `${element.code}`})
                    });
                }

                setBusinessUnits(aux_array);
            }
            catch (error) {
                setBusinessUnits([]);
            }
        }
        
        if (businessUnits === null) {
            getData()
        }
    }, [businessUnits, setBusinessUnits]);
}
const useGetListBusinessUnits = (businessUnits, setBusinessUnits) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getBusinessUnits();
                const response = serviceResponse.data;
                const aux_array = [];

                if (response.succeeded) {
                    response.data.forEach(element => {
                        aux_array.push({
                            legalEntityId: element.legalEntityId,
                            key: element.id,
                            text: `${element.legalEntityName}: ${element.name}`,
                            title: `${element.legalEntityName}: ${element.name}`})
                    });
                }

                const aux_array_ordered = aux_array.sort(dynamicSort("title"));

                setBusinessUnits(aux_array_ordered);
            }
            catch (error) {
                setBusinessUnits([]);
            }
        }
        
        if (businessUnits === null) {
            getData()
        }
    }, [businessUnits, setBusinessUnits]);
}

const useGetClientListBusinessUnits = (businessUnits, setBusinessUnits) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getBusinessUnitsFiltred();
                const response = serviceResponse.data;
                const aux_array = [];

                if (response.succeeded) {
                    response.data.forEach(element => {
                        aux_array.push({
                            legalEntityId: element.legalEntityId,
                            key: element.id,
                            text: `${element.legalEntityName}: ${element.name}`,
                            title: `${element.legalEntityName}: ${element.name}`})
                    });
                }

                const aux_array_ordered = aux_array.sort(dynamicSort("title"));

                setBusinessUnits(aux_array_ordered);
            }
            catch (error) {
                setBusinessUnits([]);
            }
        }
        
        if (businessUnits === null) {
            getData()
        }
    }, [businessUnits, setBusinessUnits]);
}

export {
    useGetBusinessUnits,
    useGetListBusinessUnits,
    useGetClientListBusinessUnits,
    useGetBusinessUnitsMaintainer,
}